export default {
      id: "passes-user-action-download-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#passes-user-action-download",
      toString: function () {
        return this.url;
      }
    }